<template>
	<el-dialog title="分拨" :visible.sync="visible" :before-close='assignStateStateClose' width="1150px" :close-on-click-modal="false">
		<!-- 头部表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="title" label="商品名称" :key="1" width="200"/>
			<el-table-column prop="skuValue" label="规格" :key="2"/>
			<el-table-column prop="unit" label="单位" :key="3" align="center"/>
			<el-table-column prop="goodsCount" label="采购数量" :key="4" align="center"/>
			<el-table-column prop="validationData.paidCount" label="实收数量" :key="5" align="center"/>
			<el-table-column prop="validationData.givingCount" label="赠品数量" :key="6" align="center"/>
			<el-table-column label="总计数量" :key="7" align="center">
        <span>{{ num }}</span>
			</el-table-column>
		</el-table>
	
		<!-- 有效期分拨 -->
		<el-table :data="storeTable" style="width: 100%">
			<el-table-column prop="shop_name" label="门店" :key="1" width="80"/>
			<el-table-column  prop="requestCount" label="所需采购数量" :key="3" width="120" align="center">
			</el-table-column>
      <el-table-column prop="fenboNum" label="分拨数量" :key="2" align="center" width="120">
        <template slot-scope="scope">
					<span>{{scope.row.fenboNum}}</span>
				</template>
      </el-table-column>
			<el-table-column prop="date" :key="4" align="center">
				<template slot-scope="scope">
					<el-input-number v-model="scope.row.fenboNum" controls-position="right" :min="0" size="small" @change="handleFenboChange(scope)"></el-input-number>
				</template>
			</el-table-column>
		</el-table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleAssignClick">确认分拨</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import {
		procureGoodsDistribution
	} from '@/api/purchaseApiNew.js'
	export default {
		props: {
			assignState: { //显示状态
				default: false
			},
			assignData: {
				default: {}
			},
			id: {
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				tableData:[],  //表头表格数据
				storeTable:[], //分拨门店表格
        num:0,
			};
		},
		created() {
      console.log(this.assignData,'tableDatatableDatatableData');
			this.tableData = [this.assignData];
    
     let num=this.assignData.validationData.paidCount+this.assignData.validationData.givingCount
     this.num=num
			let procurez_request_list = this.assignData.shopRquestRemark;  //门店所需数量
      let procure_goods_list = this.assignData.shopDistributionGoodList;
			let storeArr = [{shop_id:"5e9412e0b2bfbc089daerr12",shop_name:'金水区店'},
     { shop_id: "5e9412e0b2bfbc089daerr18", shop_name: "郑东新区店" },
			{ shop_id: "5e9412e0b2bfbc089daerr10", shop_name: "驯养中心" },
      { shop_id: "5e9412e0b2bfbc089daerr14", shop_name: "指挥中心" },];
			console.log(procurez_request_list,storeArr,'////')
			//添加门店所需采购数量
			for(let i = 0;i<storeArr.length;i++){
				//循环添加门店所需采购数量
				if(procurez_request_list != null){
					storeArr[i].requestCount = '--'
					for(let j = 0;j<procurez_request_list.length;j++){
						if(procurez_request_list[j].shopInfo.shopId == storeArr[i].shop_id){
							storeArr[i].requestCount = procurez_request_list[j].requestCount
						}
					}
				}else{
					storeArr[i].requestCount = '--'
				}
        let fenboNum = 0;
       
        if(procure_goods_list != null){
         
					for(let j = 0;j<procure_goods_list.length;j++){
            fenboNum += procure_goods_list[j].distributionCount;
					}
				}
        storeArr[i].fenboNum = fenboNum;
        
			}
     
			console.log('重组门店',storeArr)
			this.storeTable = storeArr
			console.log(this.storeTable)
		},
		methods: {
			//确认分拨
			handleAssignClick(){
				// console.log(this.assignData)
				let allCount = (this.assignData.validationData.paidCount + this.assignData.validationData.givingCount);
				let paidCount = this.assignData.validationData.paidCount;
				let givingCount = this.assignData.validationData.givingCount;
				let storeCount = 0;
        for(let m = 0; m<this.storeTable.length; m++){
					//计算门店总数量
						storeCount += this.storeTable[m].fenboNum
				}
				console.log(allCount,storeCount,'111111-----')
				if(storeCount != (paidCount+givingCount)){
					this.$message({
						message:'分拨数量必须等于实收数量加赠品数量',
						type:'warning'
					})
					return
				}
				// console.log(this.storeTable)
				let storeArr = [];
				for(let j = 0; j<this.storeTable.length;j++){
					if(this.storeTable[j].fenboNum > 0){
						storeArr[j]= this.storeTable[j]
					}
				}
				let shopDistributionGoodList = [...storeArr];
        console.log(shopDistributionGoodList,'分拨');
				shopDistributionGoodList = shopDistributionGoodList.filter(item => item);
				for(let k = 0;k<shopDistributionGoodList.length;k++){
          console.log(shopDistributionGoodList[k],'kkkk');
          shopDistributionGoodList[k].shopInfo={
            shopId:shopDistributionGoodList[k].shop_id,
						shopName:shopDistributionGoodList[k].shop_name
          }
          shopDistributionGoodList[k].distributionCount=shopDistributionGoodList[k].fenboNum
				}
				for(let a = 0;a<shopDistributionGoodList.length;a++){
					delete shopDistributionGoodList[a].requestCount;
					delete shopDistributionGoodList[a].fenboNum;
					delete shopDistributionGoodList[a].shop_id;
					delete shopDistributionGoodList[a].shop_name;
				}
				console.log('有数量的门店',shopDistributionGoodList);
				
				let parmars = {
					procureGoodsId:this.assignData.id,
					shopDistributionGoodList:shopDistributionGoodList,
				}
				console.log(parmars)
				procureGoodsDistribution(parmars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message:'分拨成功',
							type:'success'
						})
						this.$emit("refresh", false);
					}
				})
			},
			//计算分拨数量
			handleFenboChange(scope){
				console.log(scope,'scope');
				let num = 0;
        num=scope.row.fenboNum
				this.$set(this.storeTable[scope.$index],['fenboNum'],num);
			},
			//向父组件发射关闭弹框
			assignStateStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
	
		},
		watch: {
			// 监视状态发生改变
			assignState() {
				this.visible = this.assignState;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.dateView{
		display: flex;
		line-height: 54px;
		font-size: 16px;
		color: #2A2A2A;
		align-items: center;
		border-bottom: solid 1px #F5F5F5;
		.dateName{
			margin-right: 20px;
			font-weight: bold;
			margin-left: 20px;
		}
		.dateItem{
			display: flex;
			align-items: center;
			div{
				margin-right: 20px;
			}
		}
	}
	.dateView:nth-child(even){
		background: #F5F5F5;
	}
</style>
